import { useEffect } from 'react';

// Component to set security headers via meta tags
// Note: Some headers (X-Frame-Options, frame-ancestors, Permissions-Policy) can ONLY be set 
// via HTTP headers and will cause console errors if set via meta tags. These are handled 
// by Cloudflare reverse proxy instead.
export const SecurityHeaders = () => {
  useEffect(() => {
    // Set Content Security Policy via meta tag
    // Note: frame-ancestors directive is excluded as it's only valid via HTTP headers
    const cspMeta = document.createElement('meta');
    cspMeta.httpEquiv = 'Content-Security-Policy';
    cspMeta.content = [
      "default-src 'self'",
      "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.onesignal.com https://onesignal.com",
      "style-src 'self' 'unsafe-inline'",
      "img-src 'self' data: https: blob:",
      "font-src 'self' data:",
      "connect-src 'self' https://*.supabase.co https://ai.gateway.lovable.dev https://cdn.onesignal.com wss://*.supabase.co",
      "frame-src 'self'",
      "object-src 'none'",
      "base-uri 'self'",
      "form-action 'self'",
      "upgrade-insecure-requests"
    ].join('; ');
    document.head.appendChild(cspMeta);

    // Set X-Content-Type-Options
    const noSniffMeta = document.createElement('meta');
    noSniffMeta.httpEquiv = 'X-Content-Type-Options';
    noSniffMeta.content = 'nosniff';
    document.head.appendChild(noSniffMeta);

    // Set Referrer Policy
    const referrerMeta = document.createElement('meta');
    referrerMeta.name = 'referrer';
    referrerMeta.content = 'strict-origin-when-cross-origin';
    document.head.appendChild(referrerMeta);

    return () => {
      // Cleanup on unmount
      document.head.removeChild(cspMeta);
      document.head.removeChild(noSniffMeta);
      document.head.removeChild(referrerMeta);
    };
  }, []);

  return null;
};
